import { render, staticRenderFns } from "./SuiteApp.vue?vue&type=template&id=3518f8a6&"
import script from "./SuiteApp.vue?vue&type=script&lang=js&"
export * from "./SuiteApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports